import React from "react";
import { CardHeader, CardTitle } from "@/components/ui/card";

export const PlansHeader = () => {
  return (
    <CardHeader>
      <CardTitle>Gerenciamento de Planos</CardTitle>
    </CardHeader>
  );
};